export default theme => ({
  email: {
    width: "100%",
    padding: "15px !important",
  },
});
